import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FiArrowUp } from "react-icons/fi";

const Impressum = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScrollButton(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gray-50 text-[#103d5b] py-28 px-4 sm:px-8 leading-relaxed">
      
      {/* ===== روابط التنقل ===== */}
      <div className="flex flex-wrap justify-center items-center mb-10 gap-4">
        <Link
          to="/"
          className="btn "
        >
          Zur Startseite
        </Link>
        <Link
          to="/datenschutz"
          className="btn"
        >
          Datenschutz
        </Link>
      </div>

      {/* ===== المحتوى الرئيسي ===== */}
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 sm:p-10 border border-gray-100">
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-8 text-center text-[#103d5b]">
          Impressum
        </h1>

        <div className="text-[15px] sm:text-base space-y-6">

          <section>
            <p className="font-bold leading-relaxed">
              Youka GmbH<br />
              Rungestraße 13<br />
              10179 Berlin
            </p>
            <p className="font-semibold mt-3">
              Vertreten durch den Geschäftsführer:<br />
              Youssef El-Khatib
            </p>
            <p className="mt-3">
              Amtsgericht Charlottenburg, HRB 270930<br />
              Inhaltlich Verantwortlicher nach § 18 Abs. 2 MStV: Youssef El-Khatib
            </p>
          </section>

          <section>
            <p>Umsatzsteuer-Identifikationsnummer gem. § 27a Umsatzsteuergesetz: <strong>DE290651103</strong></p>
            <p>Steuernummer: <strong>30/602/50856</strong></p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#7da893] mb-2">Kontakt</h2>
            <p>
              Telefon: +49 (0) 30 85968082<br />
              E-Mail: info@youka-gmbh.com
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#7da893] mb-2">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#103d5b] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#7da893] mb-2">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-[#7da893] mb-2">
              Zentrale Kontaktstelle nach dem Digital Services Act (DSA)
            </h2>
            <p>
              Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:
            </p>
            <p>
              E-Mail: info@youka-gmbh.com<br />
              Telefon: +49 (0) 30 85968082
            </p>
            <p>
              Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch, Englisch.
            </p>
          </section>

          <section>
            <p>
              Einige der Videos auf dieser Website wurden freundlicherweise von{" "}
              <a
                href="https://pixabay.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#103d5b] hover:underline"
              >
                Pixabay
              </a>{" "}
              zur Verfügung gestellt. Wir danken den Urhebern für ihre großzügigen Beiträge und ihre Arbeit.
            </p>

            <p className="text-sm text-gray-500 mt-4">
              Quelle:{" "}
              <a
                href="https://www.e-recht24.de"
                className="text-[#7da893] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                e-recht24.de
              </a>
            </p>
          </section>

        </div>
      </div>

      {/* ===== زر الرجوع إلى الأعلى ===== */}
      {showScrollButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 w-12 h-12 flex items-center justify-center rounded-full bg-[#7da893] hover:bg-[#6b947e] text-white shadow-lg transition-all duration-300 z-40"
        >
          <FiArrowUp size={24} />
        </button>
      )}
    </div>
  );
};

export default Impressum;
